import { render, staticRenderFns } from "./Empty-Data-Placeholder.vue?vue&type=template&id=6bc60e30&scoped=true&lang=pug"
import script from "./Empty-Data-Placeholder.vue?vue&type=script&lang=ts"
export * from "./Empty-Data-Placeholder.vue?vue&type=script&lang=ts"
import style0 from "./Empty-Data-Placeholder.vue?vue&type=style&index=0&id=6bc60e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc60e30",
  null
  
)

export default component.exports